import { 
  Accordion, 
  AccordionDetails, 
  AccordionSummary, 
  Typography,
  Card 
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import React, { memo } from 'react'
import { useThemeMode } from "hooks/useThemeMode";
import { darkPalette } from "helpers/themeColors";
import { accordionStyles } from './styles'
import Delete from '@mui/icons-material/Delete';
import RegularButton from 'components/CustomButtons/Button';
import { FormContractVariantEdit } from './FormContractVariantEdit';

export const ContractVariantAccordion = memo((props) => {
  const { variant, variants, setVariants } = props
  const { isDark } = useThemeMode();
  const classes = accordionStyles({ isDark });

  return (
    <>
      <Card className={`${classes.border} `} sx={{width: '100%', boxShadow: 3}}>                  
        <Accordion style={{backgroundColor: isDark ? darkPalette.altRowBg : 'rgba(238, 238, 238 ,1)'}}>
          <AccordionSummary
            expandIcon={ <ExpandMoreIcon className={classes.icon} style={isDark ? { color: darkPalette.textPrimary } : {}} /> }
            className={ `${classes.box} ${classes[variant.isComplete]}` }
          >
            <Typography style={{alignSelf: 'center', color: isDark ? darkPalette.accent : '#004F9F'}} className={classes.heading}>{variant.name}</Typography>
            <RegularButton 
              round 
              justIcon 
              color={"danger"} 
              disabled={variants.length === 1}
              style={{ margin: 0 }} 
              onClick={(e) => {
                e.stopPropagation()
                setVariants(variants.filter(item => item.id !== variant.id))
              }}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
          </AccordionSummary>
          <AccordionDetails>
            <FormContractVariantEdit variantHandlers={props} />
          </AccordionDetails>
        </Accordion>
      </Card>
    </>
  )
})
